/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Component } from "react"
import { forEach, split, invert, concat, flatMap, join, uniqueId } from "lodash"
import fetch from "cross-fetch"
import InfiniteScroll from "react-infinite-scroller"
import queryString from "query-string"

import SearchFilter from "../search-filter"
import SearchBar from "../search-bar"
import EventCard from "../event-card"
import Loader from "../loader"

import { months } from "../../helpers/dateHelper"
import countries from "../../helpers/countries"
import programs from "../../helpers/programs"
import eventTypes from "../../helpers/eventTypes"
import * as Icon from "react-feather"

function buildCountryOptions() {
  const countryOptions = []
  forEach(countries, (val, key) => {
    countryOptions.push({
      name: val,
      value: key,
    })
  })

  return countryOptions
}

function buildSearchQuery(search) {
  const searchWords = split(search, " ")
  return `${searchWords.join("* | ")}*`
}

function handleQueryString() {
  const filters = []
  if (typeof window !== "undefined") {
    const query = queryString.parse(window.location.search)
    const program = query.program
    const country = query.country
    const eventType = query.eventtype

    if (country) {
      const countryCode = invert(countries)[country]
      if (countryCode) {
        filters.push({
          field: "Country",
          options: [countryCode],
        })
      }
    }

    if (program) {
      const qsPrograms = split(program, ",")
      const options = []

      qsPrograms.forEach((qsProgram) => {
        const programCode = invert(programs)[qsProgram]
        if (programCode) {
          options.push(programCode)
        }
      })

      if (options.length) {
        filters.push({
          field: "Programs",
          options,
        })
      }
    }

    if (eventType) {
      const qsEvents = split(eventType, ",")
      const options = []

      qsEvents.forEach((qsEvent) => {
        const eventCode = invert(eventTypes)[qsEvent]
        if (eventCode) {
          options.push(eventCode)
        }
      })

      if (options.length) {
        filters.push({
          field: "Type",
          options,
        })
      }
    }
  }

  return filters
}

class EventSearch extends Component {
  filters = [
    {
      style: "search",
      title: "Country",
      field: "Country",
      placeholder: "Filter by Country",
      options: buildCountryOptions(),
    },
    {
      style: "tags",
      title: "Programs",
      field: "Programs",
      options: [
        {
          key: "MA",
          label: "Masters",
        },
        {
          key: "MBA",
          label: "One-Year MBA",
        },
        {
          key: "EMBA",
          label: "Executive MBA",
        },
        {
          key: "BIBA",
          label: "Bachelor of Business Administration",
        },
      ],
    },
    {
      style: "other",
      title: "Event Type",
      field: "Type",
      options: [
        "Campus Visit",
        "Educational Fair",
        "Visionary Speaker Series",
        "Experience Hult",
        "Info Session",
        {
          key: "121",
          label: "One-to-One",
        },
        "Open House",
        "Webinar",
        "Online Meeting",
      ],
    },
  ]

  page = 0
  size = 10

  constructor(props) {
    super(props)

    this.search = this.search.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.onFilterChange = this.onFilterChange.bind(this)
    this.buildQueryStringSearch = this.buildQueryStringSearch.bind(this)

    const filters = handleQueryString()

    this.state = {
      loading: true,
      events: [],
      search: "",
      filters,
      offset: 0,
      total: 0,
    }
  }

  search() {
    this.page += 1
    const { search, filters, offset, events } = this.state

    fetch(`${process.env.GATSBY_HULTEDUDATA_API}/events/search`, {
      method: "POST",
      body: JSON.stringify({
        from: offset,
        size: this.size,
        search: buildSearchQuery(search),
        filters,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.status >= 400) {
          throw new Error("Bad response from server")
        }
        return res.json()
      })
      .then((result) => {
        this.setState({
          events: concat(
            events,
            flatMap(result.hits.hits, (f) => f._source)
          ),
          loading: false,
          total: result.hits.total,
          offset: this.page * this.size,
        })
      })
      .catch((err) => {
        console.error(err)
      })
  }

  onSearchChange(searchValue) {
    this.page = 0
    this.setState({
      search: searchValue,
      events: [],
      offset: 0,
      total: 0,
      loading: true,
    })
  }

  onFilterChange(filters) {
    this.page = 0
    this.setState({
      filters,
      events: [],
      offset: 0,
      total: 0,
      loading: true,
    })
  }

  buildQueryStringSearch() {
    if (typeof window !== "undefined") {
      const { filters } = this.state
      const basePath = `${window.location.origin}${window.location.pathname}`
      const parsedFilters = []
      let url = basePath

      filters.forEach((filter) => {
        switch (filter.field) {
          case "Country":
            parsedFilters.push(
              `country=${join(
                filter.options.map((o) => countries[o]),
                ","
              )}`
            )
            break
          case "Programs":
            parsedFilters.push(
              `program=${join(
                filter.options.map((o) => programs[o]),
                ","
              )}`
            )
            break
          case "Type":
            parsedFilters.push(
              `eventtype=${join(
                filter.options.map((o) => eventTypes[o]),
                ","
              )}`
            )
            break
          default:
            break
        }
      })

      if (parsedFilters.length > 0) {
        url = `${basePath}?${join(parsedFilters, "&")}`
      }

      this.clipboard.value = url
      this.clipboard.select()

      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(url)
      } else {
        document.execCommand("copy")
      }

      this.clipboard.value = "Get link"
    }
  }

  render() {
    const { filters, loading, events, offset, total } = this.state

    return (
      <div className="event-search grid grid--gutters-sm grid--v-top">
        <div className="event-search__filter grid__col grid__col--1-4 grid__col--md-1-1">
          <div className="grid grid--gutters-xsm">
            <div className="grid__col grid__col--1-1 grid__col--md-1-2">
              <SearchFilter
                filterGroups={this.filters}
                filters={filters}
                onChange={this.onFilterChange}
              />
            </div>
            <div className="grid__col grid__col--1-1 grid__col--md-1-2">
              <div className="event-search__link">
                <input
                  className="event-search__link-input btn btn--wide"
                  type="text"
                  value="Get link"
                  onClick={this.buildQueryStringSearch}
                  onChange={() => {}}
                  ref={(ref) => {
                    this.clipboard = ref
                  }}
                />
                <Icon.Link className="event-search__link-icon event-search__link-icon--not-copied icon icon--sm" />
                <Icon.Check className="event-search__link-icon event-search__link-icon--copied icon icon--sm" />
              </div>
            </div>
          </div>
        </div>
        <div className="grid__col grid__col--3-4">
          <div className="grid grid--gutters-md grid--v-top">
            <div className="grid__col grid__col--1-1">
              <SearchBar
                resultCount={events.length}
                totalCount={total}
                placeholder={"Search for an event..."}
                onSearchChange={this.onSearchChange}
              />
            </div>
          </div>

          <div className="grid grid--gutters-md grid--v-top">
            <div className="grid__col grid__col--1-1">
              <InfiniteScroll
                pageStart={0}
                loadMore={this.search}
                hasMore={loading || offset < total}
                loader={<Loader key={0} />}
                className="search-results grid grid--gutters-xsm"
                threshold={500}
              >
                <>
                  {events.map((e) => {
                    const date = new Date(e.StartDatetime)
                    return (
                      <div
                        key={uniqueId(e.Id)}
                        className="grid__col grid__col--1-1 grid__col--lg-1-1"
                      >
                        <a
                          href={e.Link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <EventCard
                            name={e.Title}
                            description={e.Description}
                            day={date.getUTCDate()}
                            month={months[date.getUTCMonth()]}
                            year={date.getUTCFullYear()}
                            location={e.Country}
                            type={e.Type}
                            programs={e.Programs}
                          />
                        </a>
                      </div>
                    )
                  })}
                </>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EventSearch
